module.exports = __webpack_public_path__ + "img/bloody.df925f0a.png";